import { IPetState, petActions } from "../../../state/pet";
import { useDispatch, useSelector } from "react-redux";

import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { IRootState } from "../../../state";
import { ISOCItemResponse } from "../../../services/pet-detail/pet-detail.interface";
import { PetFormType } from "../../../services/pet-create/pet-create.schema";

export const usePetStore = () => {
  const dispatch = useDispatch();
  const {
    newPetForm, petInfo, petInfoMap, SOCSelected, petList,
  } = useSelector((state: IRootState) => state.pet as IPetState);

  const setSOCSelected = (soc: ISOCItemResponse) => {
    dispatch(petActions.setSOCSelect(soc));
  };

  const setNewPetImage = (payload: File | null): void => {
    dispatch(petActions.setNewPetImage(payload));
  };

  const setNewPetForm = (payload: PetFormType | null): void => {
    dispatch(petActions.setNewPetForm(payload));
  };

  const setPetInfo = (payload: IPetItemResponse | null): void => {
    dispatch(petActions.setPetInfo(payload));
  };

  const setPetList = (payload: IPetItemResponse[] | null): void => {
    dispatch(petActions.setPetList(payload));
  };


  const clearPetInfoMap = (): void => {
    dispatch(petActions.clearPetInfoMap());
  };

  return {
    setPetInfo,
    petInfo,
    petInfoMap,
    clearPetInfoMap,
    setSOCSelected,
    SOCSelected,
    setNewPetImage,
    setNewPetForm,
    newPetForm,
    setPetList,
    petList,
  };
};
